import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var themeOptions = function () { return ({
    components: {
        MuiChip: {
            styleOverrides: {
                root: {
                    fontSize: '14px',
                    color: designTokens.color.gray.slateDark.value,
                    paddingTop: '7px',
                    paddingBottom: '7px',
                    paddingLeft: '5px',
                    paddingRight: '5px',
                    fontWeight: 'normal', // just to prevent accidentally inheriting different value from container
                },
                sizeSmall: {
                    fontSize: '12px',
                },
                label: {
                    paddingTop: '0',
                    paddingBottom: '0',
                    paddingLeft: '5px',
                    paddingRight: '5px',
                },
                filled: {
                    backgroundColor: designTokens.color.gray.light.value,
                    '&:hover': { backgroundColor: designTokens.color.gray.light.value },
                },
                outlined: {
                    borderColor: designTokens.color.gray.accent.value,
                },
                icon: {
                    fontSize: '16px',
                    paddingTop: '0',
                    paddingBottom: '0',
                    paddingLeft: '5px',
                    paddingRight: '0',
                    margin: '0',
                },
                deleteIcon: {
                    // unfortunately this is needed due to Stylebitz interference; TODO remove when Stylebitz no longer coexists with Pigment in our frontend apps
                    boxSizing: 'unset',
                    fill: designTokens.color.gray.limestone.value,
                    fontSize: '16px',
                    paddingTop: '0',
                    paddingBottom: '0',
                    paddingLeft: '0',
                    paddingRight: '5px',
                    margin: '0',
                },
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                colorPrimary: {
                    fill: designTokens.color.gray.slateDark.value,
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=chipTheme.js.map